import React, { Dispatch } from "react";
import { reducer, initialState } from "./reducer";
import { LanguageAction } from "../../types";

interface ExtendedLanguageState {
  language: 'en' | 'mk';
  languages: string[];
  languageContents: Record<string, Record<string, string>>;
  translations: Record<string, string>;
}

type LanguageContextType = [ExtendedLanguageState, Dispatch<LanguageAction>];

export const LanguageContext = React.createContext<LanguageContextType>([
  initialState,
  () => null,
]);

interface LanguageProviderProps {
  children: React.ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <LanguageContext.Provider value={[state, dispatch]}>
      {children}
    </LanguageContext.Provider>
  );
};
